import { render, staticRenderFns } from "./TplTable.vue?vue&type=template&id=dabe90ec&scoped=true&"
import script from "./TplTable.vue?vue&type=script&lang=js&"
export * from "./TplTable.vue?vue&type=script&lang=js&"
import style0 from "./TplTable.vue?vue&type=style&index=0&id=dabe90ec&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dabe90ec",
  null
  
)

export default component.exports